export default __webpack_public_path__ + "static/media/menu-flatbread.01f08584.png";